//React
import React from 'react';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as partnerAction from '../action/partnerAction';
//Add
import moment from 'moment';
//Material-ui
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

//Icon
import AddCircleIcon from '@material-ui/icons/AddCircle';

//Part

//Dialog
import DialogQaAnswerAddConfirm from './DialogQaAnswerAddConfirm';
import DialogConfirm from './DialogConfirm';

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pic: props.pic,
      list: [],
      answerAddQaId: null,
      answerAddText: '',
      answerDelQaId: null,
      datetime: null,
  	}
  }

  componentDidMount() {
    this._partnerQaQuestionListGet(false);
  }

  _partnerQaQuestionListGet(scroll) {
    this.props.partnerQaQuestionListGet(this.state.pic, (data) => {
      this.setState({
        list: data.list,
        datetime: new Date(),
      });
    });
  }


  _renderList(item, index) {
    return (
      <div key={index} className='box_outer'>
        <Box className='box_inner round12' boxShadow={2} style={{margin:'10px', background:'#FFF'}}>
          <div style={{padding:'2%'}}>
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'top'}}>
              <div style={{display:'flex',flexDirection:'row',justifyContent:'start'}}>
                <div>
                  {
                    (moment(item.qa_date).isValid()) && (
                      moment(item.qa_date).format("YYYY年MM月DD日")
                    )
                  }
                </div>
              </div>
            </div>


            <div style={{margin:'10px',fontSize:'1.1em',fontWeight:'bold',color:'#333',whiteSpace:'pre-line'}}>
              {item.qa_question}
            </div>
            {
              (this.state.pic !== this.props.auth.uic && item.qa_my_answer) ?
              <div>
                <div>
                  <div style={{margin:'5px'}}>

                    <span className='orange_icon'>回答済み</span>
                    { item.qa_my_answer }

                    <AddCircleIcon
                      onClick={ () => this.setState({answerDelQaId: item.qa_id}) }
                      style={{
                        transform:'rotate(45deg)',
                        verticalAlign:'middle',
                        cursor:'pointer',
                        color:'#ccc',
                      }}
                    />
                  </div>
                </div>
              </div> :
              <div>
                {
                  (Array.isArray(item.qa_answer) === true) &&
                  item.qa_answer.map(
                    (value, index) => this._renderAnswer(value, index, item.qa_id)
                  )
                }
              </div>
            }

          </div>
        </Box>
      </div>
    );
  };

  _renderAnswer(value, index, qa_id) {
    return (
      <div key={index} style={{margin:'5px'}}>
        <Button
          size="large"
          variant="outlined"
          onClick={ () => this._partnerQaQuestionAnswerAddDialog(qa_id, value) }
          style={{textAlign:'left'}}
        >
          { value }
        </Button>
      </div>
    );
  }

  _partnerQaQuestionAnswerAddDialog(qa_id, value) {
    if (this.state.pic === this.props.auth.uic) {
      return false;
    }
    this.setState({answerAddQaId:qa_id, answerAddText: value});
  }

  _partnerQaQuestionAnswerAddSubmit(qaAnswerOpen) {
    this.props.partnerQaQuestionAnswerAdd(this.state.answerAddQaId, qaAnswerOpen, this.state.answerAddText, () => {
      let newList = Object.assign([], this.state.list);
			let index = newList.findIndex((value) => value.qa_id === this.state.answerAddQaId);
			if (index >= 0) {
				newList[index].qa_my_answer = this.state.answerAddText;
        this.setState({list: newList, answerAddQaId:null, answerAddText:''})
			}
      this.props.qaQuestionAnsweredCountEdit(1);
    })
  }

  _partnerQaQuestionAnswerDelSubmit() {
    this.props.partnerQaQuestionAnswerDel(this.state.answerDelQaId, () => {
      let newList = Object.assign([], this.state.list);
			let index = newList.findIndex((value) => value.qa_id === this.state.answerDelQaId);
			if (index >= 0) {
				newList[index].qa_my_answer = null;
        this.setState({list: newList, answerDelQaId:null})
			}
      this.props.qaQuestionAnsweredCountEdit(-1);
    })
  }

	render() {
    let qaQuestionNonAnsweredCount = this.props.qaQuestionCount - this.props.qaQuestionAnsweredCount;

      if (!this.state.datetime) {
        return (
          <div id='partnerQaQuestionList' style={{height:'1000px'}}></div>
        );
      }
      else {
        return (
    			<div id='partnerQaQuestionList'>
            {
              (this.state.list.length > 0) ? (
                <div>
                  <div
                    style={{
                      display:'flex',
                      flexDirection:'row',
                      alignItems:'center',
                      justifyContent: 'space-between',
                      margin: '10px',
                    }}
                  >
                    <div>
                      { this.props.qaQuestionCount }問
                    </div>
                    <div>
                      {
                        (qaQuestionNonAnsweredCount > 0) && (
                          <span className='orange_icon'>
                            {qaQuestionNonAnsweredCount}問が未回答
                          </span>
                        )
                      }
                    </div>
                  </div>
                  {
                    this.state.list.map(
                      (value, index) => this._renderList(value, index)
                    )
                  }
                </div>
              ) : (
                <h2 align='center'>質問はありませんでした</h2>
              )
            }
            <DialogQaAnswerAddConfirm
              open={ (this.state.answerAddQaId && this.state.answerAddText) ? true: false }
              pic={this.state.pic}
              answerAddQaId={this.state.answerAddQaId}
              answerAddText={this.state.answerAddText}
              apply={ (qaAnswerOpen) => this._partnerQaQuestionAnswerAddSubmit(qaAnswerOpen) }
              close={ () => this.setState({answerAddQaId:null, answerAddText:''}) }
            />
            <DialogConfirm
              open={ (this.state.answerDelQaId) ? true : false }
              title={'Q&Aの回答を削除'}
              content={'Q&Aの回答を削除してもいいですか？'}
              apply={ () => this._partnerQaQuestionAnswerDelSubmit() }
              close={ () => this.setState({answerDelQaId:null}) }
            />
    			</div>
    		)
      }


	}
}

const mapStateToProps = (state) => {
	return {
    auth: state.auth,
    partner: state.partner,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...partnerAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
